import * as React from 'react';
import {Pagination, PaginationItem, PaginationLink} from 'reactstrap';
import ChevronRightIcon from 'mdi-react/ChevronRightIcon';
import ChevronLeftIcon from 'mdi-react/ChevronLeftIcon';

interface PaginacionProps {
    numFound: number;
    pageSize: number;
    page: number;
    handleClick: (page: number) => void;
}

interface PaginacionState {
    pages: number;
}

export default class Paginacion extends React.Component<PaginacionProps, PaginacionState> {

    constructor(props) {
        super(props);
        const pages = Math.ceil(props.numFound / props.pageSize);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            pages
        }
    }

    public componentWillReceiveProps(props) {
        const pages = Math.ceil(props.numFound / props.pageSize);
        this.setState({pages});
    }

    private handleClick(page) {
        this.props.handleClick(page);
    };

    private handleMoveForward = () => {
        const {page} = this.props;
        const {pages} = this.state;
        if (page < pages) {
            this.handleClick(page + 1);
        }
    };

    private handleMoveBackward = () => {
        const {page} = this.props;
        if (page > 1) {
            this.handleClick(page - 1);
        }
    };

    private get pages() {
        const content: any[] = [];
        for (let i = 1; i <= this.state.pages; i++) {
            if (this.props.page - i >= -5 && this.props.page - i <= 5) {
                content.push(<PaginationItem active={i === this.props.page} key={`page-item-${i}`}
                                             className='pagination__item' onClick={() => this.handleClick(i)}>
                    <PaginationLink key={`page-link-${i}`} className='pagination__link'>{i}</PaginationLink>
                </PaginationItem>)
            }

        }
        return content;
    };

    public render() {
        return (
            this.state.pages > 0 ? <div className='pagination__wrap'>
                <Pagination className='pagination' aria-label='Page navigation example'>
                    <PaginationItem className='pagination__item' onClick={this.handleMoveBackward}>
                        <PaginationLink className='pagination__link'>
                            <ChevronLeftIcon className='pagination__link-icon'/>
                        </PaginationLink>
                    </PaginationItem>
                    <>
                        {this.pages}
                    </>
                    <PaginationItem className='pagination__item' onClick={this.handleMoveForward}>
                        <PaginationLink className='pagination__link'>
                            <ChevronRightIcon className='pagination__link-icon'/>
                        </PaginationLink>
                    </PaginationItem>
                </Pagination>
                <div className='pagination-info'>
                    <span>Mostrando {this.props.pageSize > this.props.numFound ? this.props.numFound : this.props.pageSize} de {this.props.numFound} resultados - {this.state.pages} páginas</span>
                </div>
            </div> : null
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/paginacion/paginacion.tsx